/**
 * Constant representing the default percentage for paymaster operations.
 *
 * This constant is used as a percentage value based on union or non-performance financial operations.
 *
 * @const {number}
 */
export const DEFAULT_PAYMASTER_PERCENT = 5;

/**
 * Constant representing the unique identifier for the ACX signatory.
 * @const {number}
 */
export const ACX_SIGNATORY_ID = 2;

/**
 * Enum representing the possible statuses of bank details.
 *
 * This enum defines various states that bank details. It can be used to manage and track the status
 * of bank details throughout the application.
 *
 * @enum {string}
 */
export enum BankDetailsStatus {
	unknown = 'unknown',
	pending = 'pending',
	pennyTestSent = 'pennytestsent',
	confirmed = 'confirmed',
	invalid = 'invalid'
}

/**
 * Define user/company types.
 */
export enum UserRoles {
	talent,
	customer,
	agency,
	individualCustomer,
	companyCustomer
}
